// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as homeIndexRouteImport } from './routes/(home)/index'
import { Route as CallForPapersIndexRouteImport } from './routes/call-for-papers/index'
import { Route as CommitteeIndexRouteImport } from './routes/committee/index'
import { Route as DatesIndexRouteImport } from './routes/dates/index'
import { Route as SubmissionsIndexRouteImport } from './routes/submissions/index'
import { Route as VenueIndexRouteImport } from './routes/venue/index'
import { Route as WorkshopsIndexRouteImport } from './routes/workshops/index'

const homeIndexRoute = homeIndexRouteImport.update({
            id: '/(home)/',path: '/',getParentRoute: () => rootRouteImport
          })
const CallForPapersIndexRoute = CallForPapersIndexRouteImport.update({
            id: '/call-for-papers/',path: '/call-for-papers/',getParentRoute: () => rootRouteImport
          })
const CommitteeIndexRoute = CommitteeIndexRouteImport.update({
            id: '/committee/',path: '/committee/',getParentRoute: () => rootRouteImport
          })
const DatesIndexRoute = DatesIndexRouteImport.update({
            id: '/dates/',path: '/dates/',getParentRoute: () => rootRouteImport
          })
const SubmissionsIndexRoute = SubmissionsIndexRouteImport.update({
            id: '/submissions/',path: '/submissions/',getParentRoute: () => rootRouteImport
          })
const VenueIndexRoute = VenueIndexRouteImport.update({
            id: '/venue/',path: '/venue/',getParentRoute: () => rootRouteImport
          })
const WorkshopsIndexRoute = WorkshopsIndexRouteImport.update({
            id: '/workshops/',path: '/workshops/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  homeIndexRoute: homeIndexRoute,CallForPapersIndexRoute: CallForPapersIndexRoute,CommitteeIndexRoute: CommitteeIndexRoute,DatesIndexRoute: DatesIndexRoute,SubmissionsIndexRoute: SubmissionsIndexRoute,VenueIndexRoute: VenueIndexRoute,WorkshopsIndexRoute: WorkshopsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)